<template>
  <div v-html="renderedMarkdown" :class="{'souruby--off': !souruby}"></div>
</template>
  
<script setup lang="ts">
  import { computed } from "vue";
  import { markdown as md } from "@/util/markdown";
  import 'core-js/es/string/replace-all'

  const props = withDefaults(
    defineProps<{
      rawText?: string;
      workId?: number;
      souruby?: boolean;
    }>(),
    {
      rawText: "",
      workId: 0,
      souruby: false 
    }
  )

  const renderedMarkdown = computed(() => {
    let renderedMarkdownText = md.render(props.rawText);

    // 教材IDが渡された場合、リンクを置き換える
    if (props.workId !== 0) {
      // 画像URL置き換え
      renderedMarkdownText = renderedMarkdownText.replaceAll(
        `img src="`,
        `img src="/work_assets/${props.workId}/media/`
      );
      // 音声URL置き換え
      renderedMarkdownText = renderedMarkdownText.replaceAll(
          `audio src="`,
          `audio src="/work_assets/${props.workId}/media/`
      );
      // 動画URL置き換え
      renderedMarkdownText = renderedMarkdownText.replaceAll(
          `video src="`,
          `video src="/work_assets/${props.workId}/media/`
      );
    }
    // NFR-1745対応する時パータンにhtmlタグ入れなくてもよかったが、社会の人名テストで問題が発生
    // NFR-2570対応：日本語前後に半角スペースがある時除去されて表示すると入力した値とS3-9で表示する値が違うのでおかしい。
    // それを防ぐためパータンを変更：1)ひらがな/カタカナ/漢字 + スペース + タグ(<,>) 2)スペース + タグ(<,>) + ひらがな/カタカナ/漢字　
    renderedMarkdownText = renderedMarkdownText.replace(/([ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠])[ ](<)+/g, '$1$2')
    renderedMarkdownText = renderedMarkdownText.replace(/(>)[ ]+([ぁ-んァ-ヶｱ-ﾝﾞﾟ一-龠])/g, '$1$2')
    // NFR-3476 ぼかしを防ぐためtableタグはdivに囲む（padding-bottomに効かないので）
    renderedMarkdownText = renderedMarkdownText.replace(/(<table>)/g, `<div>$1</div>`)
    return renderedMarkdownText;
  })
</script>
  